import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, apiError } from "../lib/api";
import { btn, input, label } from "../lib/ui";
import { useI18n } from "../i18n";
import { AuthShell } from "./AuthShell";

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMsg(data.message);
    } catch (e) {
      setMsg(apiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title={t("pub.forgot.title")} subtitle={t("pub.forgot.subtitle")}
      footer={<Link to="/login" className="font-medium text-[#075E62] hover:text-[#0299A0]">{t("pub.forgot.footerLink")}</Link>}>
      <form onSubmit={submit} className="flex flex-col gap-4">
        <div>
          <label className={label}>{t("pub.forgot.email")}</label>
          <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={input} placeholder={t("pub.login.emailPh")} />
        </div>
        {msg && <p data-testid="forgot-message" className="text-sm text-[#075E62] bg-[#0299A0]/8 border border-[#0299A0]/30 rounded-md px-3 py-2">{msg}</p>}
        <button type="submit" data-testid="forgot-submit" disabled={busy} className={btn.accent + " w-full"}>{busy ? t("pub.forgot.submitting") : t("pub.forgot.submit")}</button>
      </form>
    </AuthShell>
  );
}
